<p-fluid>
  @if (valueFormControl()) {
    <p-floatlabel variant="on">
      <p-multiselect
        [style]
        [styleClass]="styleClass()"
        [options]="options()"
        [filter]="filter()"
        [formControl]="valueFormControl()"
        (onChange)="handleChange($event)"
        [maxSelectedLabels]="10"
        [selectedItemsLabel]="'{0} rollen geselecteerd'"
      ></p-multiselect>
      <label for="on_label">
        {{ label() }}
        @if (isRequired) {
          <span class="required-indicator">*</span>
        }
      </label>
    </p-floatlabel>
  } @else {
    <p-floatlabel variant="on">
      <p-multiselect
        [styleClass]="styleClass()"
        [options]="options()"
        [filter]="filter()"
        [ngModel]="model()"
        (onChange)="handleChange($event)"
        [appendTo]="'body'"
        [maxSelectedLabels]="10"
        [selectedItemsLabel]="'{0} rollen geselecteerd'"
      ></p-multiselect>
      <label for="on_label">
        {{ label() }}
        @if (isRequired) {
          <span class="required-indicator">*</span>
        }
      </label>
    </p-floatlabel>
  }
</p-fluid>
